import * as React from 'react';
import { Text } from '../../Typography';
export var DateRangeSeparator = function () { return (React.createElement(Text, { style: { margin: '0 1rem 0 1rem' } }, " \u2013 ")); };
//# sourceMappingURL=DateRangeSeparator.js.map